import { IconProps } from './types';

export function Home({ size, ...props }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" viewBox="0 0 25 25" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7 20.668V10.5661C19.7 10.3661 19.6145 10.1757 19.4651 10.0429L12.4651 3.82069C12.1998 3.58493 11.8002 3.58493 11.5349 3.82069L4.53495 10.0429C4.3855 10.1757 4.3 10.3661 4.3 10.5661V20.668C4.3 21.0546 4.6134 21.368 5 21.368H19C19.3866 21.368 19.7 21.0546 19.7 20.668ZM3.67127 9.07128C3.2443 9.45081 3 9.99482 3 10.5661V20.668C3 21.7725 3.89543 22.668 5 22.668H19C20.1046 22.668 21 21.7725 21 20.668V10.5661C21 9.99482 20.7557 9.45081 20.3287 9.07128L13.3287 2.84905C12.571 2.17548 11.429 2.17548 10.6713 2.84905L3.67127 9.07128Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 13.968H10C9.6134 13.968 9.3 14.2814 9.3 14.668V21.368H14.7V14.668C14.7 14.2814 14.3866 13.968 14 13.968ZM10 12.668C8.89543 12.668 8 13.5634 8 14.668V22.668H16V14.668C16 13.5634 15.1046 12.668 14 12.668H10Z"
        fill="currentColor"
      />
    </svg>
  );
}
